import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dockDoorsData: [],
  timeMachineV2ModeIsEnabled: false,
  timeMachineMaxTimeStamp: ""
};

const newTimeMachineSlice = createSlice({
  name: "newTimeMachine",
  initialState,
  reducers: {
    setNewTimeMachineDockDoorsData: (state, action) => {
      state.dockDoorsData = action.payload;
    },
    setTimeMachineV2ModeIsEnabled: (state, action) => {
      state.timeMachineV2ModeIsEnabled = action.payload;
    },
    setTimeMachineMaxTimeStamp: (state, action) => {
      state.timeMachineMaxTimeStamp = action.payload;
    }
  }
});

export const {
  setNewTimeMachineDockDoorsData,
  setTimeMachineV2ModeIsEnabled,
  setTimeMachineMaxTimeStamp
} = newTimeMachineSlice.actions;

export default newTimeMachineSlice.reducer;
